module.exports = __webpack_public_path__ + "img/logo_vertical.d0dfb798.svg";